import { Helmet } from 'react-helmet-async';

import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import { Stack, Paper, Button, Container, Typography, Tabs, Tab, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import { tabsClasses } from '@mui/material/Tabs';

import CompanyEditPage from './CompanyEditPage';

import CompanyDetails from './CompanyDetails';
import TasksList from 'src/components/Opportunities/TasksList';
import PerformActivity from 'src/components/Opportunities/PerformActivity';
import CompanyNotes from './CompanyNotes';
import AttachmentsList from '../Attachments/AttachmentsList';
import { OpenGmail } from 'src/components/services/httpServices';
import TreeView from '../TreeView/TreeView';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CompanyTabsPage() {
  let { id } = useParams();
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const OpenOutlook = async () => {
    let response = await OpenGmail();
  };
  const openGmail = () => {
    const receiverEmail = 'receiver@example.com';
    const subject = 'Hello';
    const body = 'This is the body of the email.';

    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    const gmailUrl = `https://mail.google.com/mail/?view=cm&to=${receiverEmail}&su=${encodedSubject}&body=${encodedBody}`;

    // window.location.href = gmailUrl;
    window.open(gmailUrl);
  };
  return (
    <>
      <Helmet>
        <title> Employers | Immigration System </title>
      </Helmet>
      <Container>
        {/* <Box
          p={4}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        > */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom></Typography>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
            <Button onClick={openGmail} variant="contained">
              Email
            </Button>
          </Stack>
        </Stack>

        <Box component={Paper}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="primary tabs example"
            variant="scrollable"
            scrollButtons
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
              },
            }}
          >
            <Tab label="Edit" {...a11yProps(0)} />
            <Tab label="Details" {...a11yProps(1)} />
            <Tab label="Documents" {...a11yProps(2)} />
            <Tab label="Tasks" {...a11yProps(3)} />
            <Tab label="Perform Activity" {...a11yProps(4)} />
            <Tab label="Notes" {...a11yProps(5)} />
            <Tab label="Documents Tree" {...a11yProps(6)} />
          </Tabs>

          <SwipeableViews axis="x-reverse" index={value} onChangeIndex={handleChangeIndex}>
            <TabPanel value={value} index={0}>
              <CompanyEditPage setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CompanyDetails />
              {/* <MyOpportunitiesCompanies
                setMessage={setMessage}
                setLoading={setLoading}
                setSaved={setSaved}
                setOpen={setOpen}
              /> */}
            </TabPanel>
            <TabPanel value={value} index={2}>
              <AttachmentsList setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <TasksList setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <PerformActivity setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <CompanyNotes setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
            <TabPanel value={value} index={6}>
              <TreeView setMessage={setMessage} setLoading={setLoading} setSaved={setSaved} setOpen={setOpen} />
            </TabPanel>
          </SwipeableViews>
        </Box>
        {/* </Box> */}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
